import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { Element } from "./element";
import styles from "./styles.scss";

function ConstrainedElement({ element, dateType }: Props) {
  const { t } = useTranslation();
  const startDate =
    "startDate" in element
      ? element.startDate
      : "startTime" in element
        ? element.startTime
        : "";
  const endDate =
    "endDate" in element
      ? element.endDate
      : "endTime" in element
        ? element.endTime
        : "";

  return (
    <div className={styles.constrainedElement}>
      <p className={styles.dateType}>
        {t(`constrainElement.dateTypes.${dateType}`)}
      </p>
      <p className={styles.element}>
        {t("constrainElement.of")}
        <span className={styles.name}> {element.name}</span>
      </p>
      <div className={styles.dates}>
        {!!startDate && (
          <p className={styles.date}>
            {`${t("constrainElement.startDate")}: ${new Date(
              startDate,
            ).toLocaleDateString()}`}
          </p>
        )}
        {!!endDate && (
          <p className={styles.date}>
            {`${t("constrainElement.endDate")}: ${new Date(
              endDate,
            ).toLocaleDateString()}`}
          </p>
        )}
      </div>
      <div className={styles.footer}>
        <Element element={element} />
      </div>
    </div>
  );
}

export { ConstrainedElement };
